<div class="year-picker-container">
  <input matInput [matDatepicker]="yearPicker" class="year-hidden-input" readonly>
  <input [value]="getYear()" [placeholder]="placeholder" readonly (click)="yearPicker.open()" class="year-input">
  <mat-datepicker-toggle [for]="yearPicker" class="year-toggle"></mat-datepicker-toggle>
  <mat-datepicker #yearPicker startView="multi-year" (yearSelected)="onYearSelected($event, yearPicker)"></mat-datepicker>
</div>
